__turbopack_context__.v({
  "socialMediaLink": "eSDcoq_socialMediaLink",
});
